export function assertIsDefined(val, name) {
  if (process.env.NODE_ENV !== 'production' && (val === undefined || val === null)) {
    throw new Error("Expected '".concat(name, "' to be defined, but received ").concat(val));
  }
}
//# sourceMappingURL=assert-is-defined.js.map